export const SnackbarTypes = {
	Info: 'info',
	Success: 'success',
	Warn: 'warn',
	Error: 'error',
} as const;

export type ToastType = (typeof SnackbarTypes)[keyof typeof SnackbarTypes] | keyof typeof SnackbarTypes;

export const ToastTypeIcon = {
	[SnackbarTypes.Info]: 'fa-duotone fa-info-circle',
	[SnackbarTypes.Success]: 'fa-duotone fa-check-circle',
	[SnackbarTypes.Warn]: 'fa-duotone fa-exclamation-circle',
	[SnackbarTypes.Error]: 'fa-duotone fa-times-circle',
} as const;
